import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../services/index';
import { Tabs ,Modal,message,Input,Select} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;


class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
			main_link: '',
			dayplan_link: '',
			aToken: '',
			main_menu: '',
			sub_menu: '',
			type: '',
			fees_request_count: 0,
			student_archive_count: 0,
			gate_pass_count: 0,
			cash_count: 0,
			refund_request_count: 0,
			request_cert_count: 0,
			open_concern_count: 0,
			process_concern_count: 0,
			kit_order_count: 0,
			indi_order_count: 0,
			reconc_count: 0,
			staff_leave_count: 0,
			student_leave_count: 0,
			permission: [],
		}
		this.logout = this.logout.bind(this);
	}

	change_school(event){
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = event;
        this.setState({school_id: school_id});
		var app = {
			school_id : school_id,
			user_id : user_id
		}
		getData('auth/school_change',app).then((result) => {
			if(result.status==200){
				let responseJson = result;
				if(responseJson.data){
					localStorage.setItem('schoolData',JSON.stringify(responseJson));
					var name = result['data'][0]['user_name'];
					var phone = result['data'][0]['phone'];
					var email = result['data'][0]['email'];
					var user_id = result['data'][0]['user_id'];
					var school_id = result['data'][0]['school_id'];
					var short_name = result['data'][0]['short_name'];
					var type = result['data'][0]['type'];
					var permission = result['data'][0]['permission'];
					this.setState({
						'name': name,
						'phone': phone,
						'email': email,
						'user_id': user_id,
						'school_id': school_id,
						'short_name': short_name,
						'type': type,
						'permission': permission,
					});
					var uri = window.location.toString();
					if (uri.indexOf("?") > 0) {
						var clean_uri = uri.substring(0, uri.indexOf("?"));
						window.history.replaceState({}, document.title, clean_uri);
						window.location.reload(false);
					}
				}
			}
		})
    }


	componentDidMount() {

		if(localStorage.getItem("schoolData")){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var url=window.location.pathname.split('/');
			this.setState({
				main_menu : url[1],
				sub_menu : url[2]
			});
			if(url[1] == 'fees-report'){
				setTimeout(() => {
						this.showMenu('31');
				}, 500);

			}
			var erp_id = localStorage.getItem("erp_id");
			var user_id = storedArray['data'][0]['user_id'];
			var permission = storedArray['data'][0]['permission'];
			var staff_designation = storedArray['data'][0]['staff_designation'];
			var type = storedArray['data'][0]['type'];
			var school_id = storedArray['data'][0]['school_id'];
			this.setState({ type: type,school_id:school_id,erp_id:erp_id,permission:permission,user_id:user_id,staff_designation:staff_designation });
 
			if(type == 'admin'){
				const queryParams = new URLSearchParams(window.location.search);
				var new_school_id = queryParams.get('s');

				if(new_school_id != '' && new_school_id != null ){
					setTimeout(() => {
						this.change_school(new_school_id);
					}, 500);
				}
			}

			var app = {user_id : user_id,school_id:school_id}
			getData('auth/get_login_token',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						var aToken= result['data'];
						localStorage.setItem("aToken",aToken);
						var main_link = 'https://academosedutech.com/panel/admin';
						var dayplan_link = 'https://academosedutech.com/panel/dayplan';
						this.setState({
							main_link: main_link,
							dayplan_link: dayplan_link,
							aToken:aToken
						});
					}
					else{
						var aToken='null';
						localStorage.setItem("aToken",aToken);
						var main_link = 'https://academosedutech.com/panel/admin';
						var dayplan_link = 'https://academosedutech.com/panel/dayplan';
						this.setState({
							main_link: main_link,
							dayplan_link: dayplan_link,
							aToken:aToken
						});
					}
				}
			});

			getData('auth/check_notification_count',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					setTimeout(() => {
						this.setState({
							fees_request_count: result['fees_request_count'],
							student_archive_count: result['student_archive_count'],
							gate_pass_count: result['gate_pass_count'],
							cash_count: result['cash_count'],
							refund_request_count: result['refund_request_count'],
							request_cert_count: result['request_cert_count'],
							open_concern_count: result['open_concern_count'],
							process_concern_count: result['process_concern_count'],
							indi_order_count: result['indi_order_count'],
							kit_order_count: result['kit_order_count'],
							reconc_count: result['reconc_count'],
							staff_leave_count: result['staff_leave_count'],
							student_leave_count: result['student_leave_count'],
						});
					}, 500);

				}
			});

		}else{
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}
	}

	showMenu = (id) => {
		var nav_bar = document.getElementById("nav_bar_"+id);
		var short_nav_bar = document.getElementById("short_nav_bar_"+id);

		if(nav_bar.classList.contains('active') == true){
			nav_bar.classList.remove("active");
			short_nav_bar.classList.remove("in");
		}else{
			nav_bar.classList.add("active");
			short_nav_bar.classList.add("in");
		}
	}


	logout(){
		localStorage.setItem("schoolData",'');
		localStorage.clear();
		window.location.href = '/login/';
	}

	render() {
	const {aToken}=this.state;
	const {school_id} = this.state;
	const { visible, loading } = this.state;
		return (
			<>
 

			</>
		)
	}
}
export default Index;
